import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ExtrasHub.css';

// 추가 기능 허브 — 새 기능은 이 배열에 카드를 추가
const FEATURES = [
  {
    id: 'health-insurance',
    icon: '🏥',
    title: '건강보험연말정산',
    description: '회사별 직원 월별 건강·요양보험 공제액 취합',
    features: ['임금대장 기반 자동 취합', '직원 × 월 매트릭스', '연말정산 대비 자료', '엑셀 다운로드'],
    path: '/health-insurance',
  },
];

function ExtrasHub() {
  const navigate = useNavigate();

  return (
    <div className="extras-hub">
      <div className="extras-message">
        <div className="extras-message-box">
          <h2>추가 기능</h2>
          <p>
            사용할 기능을 선택해주세요.<br />
            새로운 기능들이 이곳에 추가됩니다.
          </p>
        </div>

        <div className="extras-options">
          <div className="extras-option-cards">
            {FEATURES.map(feature => (
              <div
                key={feature.id}
                className="extras-option-card"
                onClick={() => navigate(feature.path)}
              >
                <div className="extras-option-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <div className="extras-option-features">
                  <ul>
                    {feature.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="extras-footer">
        <p>문의사항이 있으시면 관리자에게 연락해주세요.</p>
      </div>
    </div>
  );
}

export default ExtrasHub;
